import { Flex, Box, Text, Image } from "@chakra-ui/react";
import footer from "assets/images/svgs/backgroundFooter.svg";
import colors from "core/resources/theme/colors";
import SlantedButton from "ui/components/Button/SlantedButton";
import { useNavigate } from "react-router-dom";
import { useMediaQuery } from "@chakra-ui/react";
import MediaFoooter from "./components/MediaFooter";
import Informations from "./components/InformationsFooter";
import { BsFacebook, BsInstagram, BsWhatsapp } from "react-icons/bs";
import mascoteRodape from "assets/images/mascoteRodape.png";

export default function Footer() {
  const navigate = useNavigate();
  const [isLargerThan800] = useMediaQuery("(min-width: 800px)");
  const isHome = window.location.pathname === "/";
  return (
    <Box w="100vw" position="relative">
      <Box position="relative" h="300px" bg={isHome ? "white" : "#FAFAFA"}>
        <Flex
          bgImage={footer}
          backgroundRepeat="no-repeat"
          bgRepeat="no-repeat"
          bgSize="cover"
          h="300px"
        />
        <Box
          position="absolute"
          top="80%"
          left="65%"
          transform="translate(-50%, -50%)"
        >
          <SlantedButton
            title="INGRESSOS"
            color={"white"}
            bg={colors.newPink}
            onClick={() => navigate("/ingresso")}
          />
        </Box>
      </Box>

      <Informations isLargerThan800={isLargerThan800} />

      <Box position="relative">
        <Image
          src={mascoteRodape}
          alt="Mascote"
          position="absolute"
          left={["-20px", "20px", "-20px"]}
          bottom={["80px", "-40px", "30px", "-40px", "20px"]}
          zIndex="10"
          maxW={["120px", "150px", "220px"]}
        />

        <Flex
          bg={colors.newPink}
          h="max-content"
          py="20px"
          flexDir={isLargerThan800 ? "row" : "column"}
          justifyContent="center"
          color="white"
          fontWeight="medium"
          align="center"
          gap="4"
        >
          Acompanhe o Ácqua Park nas redes sociais
          <Flex gap={4}>
            <MediaFoooter
              link={"https://www.instagram.com/acquaparkpantanal"}
              icon={<BsInstagram size={20} color={colors.newBlue} />}
            />
            <MediaFoooter
              link={"https://www.facebook.com/acquaparkpantanal"}
              icon={<BsFacebook size={20} color={colors.newBlue} />}
            />
            <MediaFoooter
              link={`https://wa.me/5565999999102`}
              icon={<BsWhatsapp size={20} color={colors.newBlue} />}
            />
          </Flex>
        </Flex>
      </Box>

      <Flex
        bg={colors.yellowTerciary}
        h="60px"
        justifyContent="center"
        color={colors.purple500}
        fontWeight="medium"
        align="center"
        textAlign={"center"}
      >
        <Text fontSize={"20px"} fontWeight="500">
          © Ácqua Park Pantanal - Todos os direitos reservados
        </Text>
      </Flex>
    </Box>
  );
}
